module.exports = __webpack_public_path__ + "img/date2-icon.1e9892de.png";